import { t } from 'i18next';
import { formatDistanceToNow, parseISO } from 'date-fns';

export function useTimeAgo(initialValue) {
  const date = parseISO(new Date(initialValue).toISOString());
  const timeAgoValue = formatDistanceToNow(date, { addSuffix: true });

  // Define a mapping of time units to translation keys
  const translationKeys = {
    days: 'page.daysAgo',
    hours: 'page.hrsAgo',
    hour: 'page.hrAgo',
    day: 'page.dayAgo',
    sec: 'page.secondAgo',
    minute: 'page.minuteAgo',
    minutes: 'page.minutesAgo',
    month: 'page.monthAgo',
    months: 'page.monthsAgo',
    year: 'page.yearAgo',
    years: 'page.yearsAgo',
  };

  let unit = 'sec'; // Default unit
  let numericValue = timeAgoValue.match(/\d+/)?.[0] || '1';

  if (timeAgoValue.includes('years') || timeAgoValue.includes('year')) {
    unit = timeAgoValue.includes('years') ? 'years' : 'year';
  } else if (timeAgoValue.includes('months') || timeAgoValue.includes('month')) {
    unit = timeAgoValue.includes('months') ? 'months' : 'month';
  } else if (timeAgoValue.includes('days') || timeAgoValue.includes('day')) {
    unit = timeAgoValue.includes('days') ? 'days' : 'day';
  } else if (timeAgoValue.includes('hours') || timeAgoValue.includes('hour')) {
    unit = timeAgoValue.includes('hours') ? 'hours' : 'hour';
  } else if (timeAgoValue.includes('minutes') || timeAgoValue.includes('minute')) {
    unit = timeAgoValue.includes('minutes') ? 'minutes' : 'minute';
  }

  return `${numericValue} ${t(translationKeys[unit])}`;
}
